import { render, staticRenderFns } from "./addShops.vue?vue&type=template&id=6a04a377"
import script from "./addShops.vue?vue&type=script&lang=js"
export * from "./addShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports